import './App.css';
import Circuit from './Circuit';

function App() {
  return (
    <div className="App">
      <Circuit />
    </div>
  );
}

export default App;
